<div class="row justify-content-center">
    @for(data of clients_logo;track $index){
        <div class="{{brand_class}} icon-center">
            <img src="{{data.image}}" alt="icon" >
        </div>
    }
</div>